const Footer = () => {
	return (
		<footer className="w-full absolute z-0 bottom-0 bg-white py-3 text-center">
			<p className="md:text-lg">
				Made with ❤️ by{" "}
				<a href="https://github.com/vatsal0601" className="text-blue-600">
					Vatsal Sakariya
				</a>
			</p>
		</footer>
	);
};

export default Footer;
